import * as Yup from "yup";
import { forceInt } from "Utils";
import { transform as contentTransformer } from "./Content";

export const UrlValidationSchema = Yup.object().shape({});

export const UrlObjectSchema = {
    id: null,
    uuid: null,
    content_id: null,
    container_id: null,
    is_default: null,
    slug: null,
    content: {},
};

/**
 * It takes a URL object and returns a URL object
 * @param requestData - The data that is being transformed.
 * @returns An object with the following properties:
 *     id: A number
 *     uuid: A string
 *     content_id: A number
 *     container_id: A number
 *     is_default: A boolean
 *     slug: A string
 *     content: An object with the following properties:
 *         id: A number
 *         uuid: A string
 *         title: A string
 */
export function transform(requestData) {
    if (requestData.data) {
        return requestData.data.map((item) => transform(item));
    }

    let url = Object.assign({}, UrlObjectSchema, {
        id: forceInt(requestData.id),
        uuid: requestData.uuid,
        content_id: forceInt(requestData.content_id),
        container_id: forceInt(requestData.container_id),
        is_default: requestData.is_default,
        slug: requestData.slug,
    });

    if (requestData.content) {
        url = Object.assign({}, url, {
            content: contentTransformer(requestData.content),
        });
    }

    return url;
}
